import { CountUp } from 'countup.js';

export default function countUp(triggerSelector, targetSelector, duration, stagger) {
  const triggers = document.querySelectorAll(triggerSelector);

  triggers.forEach(trigger => {
    let targets = trigger.querySelectorAll(targetSelector);
    let counters = [];

    targets.forEach((target, index) => {
      let thisDuration = duration + stagger * index;
      let counter = new CountUp(target, target.innerText, {duration: thisDuration});
      counters.push(counter);
    });

    let observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          counters.forEach(counter => {
            counter.start();
          });
        }
        else {
          counters.forEach(counter => {
            counter.reset();
          });
        }
      });
    });
    
    observer.observe(trigger);
  });
}